import React from 'react';
import { withAppLayout } from '../core/routes';
import MediasPage from './pages/MediasPage';

export const mediasRoutes = [{ path: '/medias', element: withAppLayout(<MediasPage />) }];
